import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M738.076923 0L738.076923 147.692308 1086.63077 147.692308 680.476923 1772.30769 295 1772.30769 295 1920 1181.30154 1920 1181.30154 1772.30769 832.747692 1772.30769 1238.75385 147.692308 1624.23077 147.692308 1624.23077 0z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconItalicLine = /*#__PURE__*/function (_Component) {
  _inherits(IconItalicLine, _Component);

  var _super = _createSuper(IconItalicLine);

  function IconItalicLine() {
    _classCallCheck(this, IconItalicLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconItalicLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconItalic",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconItalicLine.displayName = "IconItalicLine";
  return IconItalicLine;
}(Component);

IconItalicLine.glyphName = 'italic';
IconItalicLine.variant = 'Line';
IconItalicLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconItalicLine;
export { IconItalicLine };